import { useEffect } from "react";
import { useAppStore } from "../store/store";
import { setAuthToken } from "../api/http";


export const AuthBridge = () => {
  const token = useAppStore(s => s.auth.token);

  useEffect(() => {
    setAuthToken(token);
  }, [token]);

  return null;
};
